<template>
  <div class="client">
    <v-content v-if="item">
      <v-carousel 
        hide-delimiters 
        show-arrows-on-hover 
        cycle height="400" v-if="extendy"
        class="hidden-sm-and-down">
        <span v-for="banner in filteredCarousel" :key="banner.id">
          <v-carousel-item 
            :src="getFirstImage(banner.cli_img)"
            v-if="getFirstImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(banner.cli_img)"
            v-if="getSecondImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(banner.cli_img)"
            v-if="getThirdImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(banner.cli_img)"
            v-if="getFourthImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getFifthImage(banner.cli_img)"
            v-if="getFifthImage(banner.cli_img)">   
          </v-carousel-item>
          <v-card-title class="align-end fill-height white--text ml-10 logo">
              <v-list-item>
                <v-list-item-avatar size="70">
                  <img :src="getImage(item.logos)" alt="Logo" />
                </v-list-item-avatar>
              </v-list-item>
          </v-card-title>
          <span class="mapit">
            <mapdirection/>
            <v-bottom-sheet v-model="sheet1" inset>
              <template v-slot:activator="{ on }">
                <v-btn fab small rounded color="grey lighten-1" 
                  style="left: 85px; position: relative; bottom: 2px;" 
                  v-on="on">
                  <v-icon>
                    mdi-share-variant
                  </v-icon>
                </v-btn>
              </template>
              <v-sheet class="text-center" height="100px">
                <div class="label"><b>Share This Client:</b></div>
                  <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/service'+ item.slug" :title="item.name" :description="item.description" quote="This Client is from Convergeo click here to view.." hashtags="convergeo services" twitter-user="Convergeo" inline-template>
                    <div>
                      <network network="facebook">
                        <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="linkedin">
                        <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="pinterest">
                        <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="skype">
                        <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="twitter">
                        <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="whatsapp">
                        <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                      </network> 
                    </div>
                  </social-sharing>
              </v-sheet>
            </v-bottom-sheet>
          </span>
          <v-card-title class="align-end fill-height white--text ml-10 main-title">
            <b class="main-title-text">
              {{ item.displayName | uppercase }}
            </b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 title">
              <b class="title-text"><i>{{ banner.description }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text crumb">
            <router-link to="/">Home</router-link>
            <v-icon>mdi-forward</v-icon>
            {{  item.displayName | capitalize }}
          </v-card-title>
        </span>
      </v-carousel>
      <v-carousel 
        hide-delimiters 
        show-arrows-on-hover 
        cycle height="200" v-else
        class="hidden-sm-and-down">
        <span v-for="banner in filteredCarousel" :key="banner.id">
          <v-carousel-item 
            :src="getFirstImage(banner.cli_img)"
            v-if="getFirstImage(banner.cli_img)">   
          </v-carousel-item>
          <v-card-title class="align-end fill-height white--text ml-10 logo">
              <v-list-item>
                <v-list-item-avatar size="70">
                  <img :src="getImage(item.logos)" alt="Logo" />
                </v-list-item-avatar>
              </v-list-item>
          </v-card-title>
          <span class="mapit">
            <mapdirection/>
            <v-bottom-sheet v-model="sheet1" inset>
              <template v-slot:activator="{ on }">
                <v-btn fab small rounded color="grey lighten-1" 
                  style="left: 85px; position: relative; bottom: 2px;" 
                  v-on="on">
                  <v-icon>
                    mdi-share
                  </v-icon>
                </v-btn>
              </template>
              <v-sheet class="text-center" height="100px">
                <div class="label"><b>Share This Client:</b></div>
                  <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/service'+ item.slug" :title="item.name" :description="item.description" quote="This Client is from Convergeo click here to view.." hashtags="convergeo services" twitter-user="Convergeo" inline-template>
                    <div>
                      <network network="facebook">
                        <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="linkedin">
                        <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="pinterest">
                        <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="skype">
                        <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="twitter">
                        <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="whatsapp">
                        <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                      </network> 
                    </div>
                  </social-sharing>
              </v-sheet>
            </v-bottom-sheet>
          </span>
          <v-card-title class="align-end fill-height white--text ml-10 main-title">
            <b class="main-title-text">
              {{ item.displayName | uppercase }}
            </b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 title">
              <b class="title-text"><i>{{ banner.description }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text crumb">
            <router-link to="/">Home</router-link>
            <v-icon>mdi-forward</v-icon>
            {{  item.displayName | capitalize }}
          </v-card-title>
        </span>
      </v-carousel>
      <v-carousel 
        hide-delimiters 
        show-arrows-on-hover 
        cycle height="210"
        class="hidden-md-and-up">
        <span v-for="banner in filteredCarousel" :key="banner.id">
          <v-carousel-item 
            :src="getFirstImage(banner.cli_img)"
            v-if="getFirstImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(banner.cli_img)"
            v-if="getSecondImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(banner.cli_img)"
            v-if="getThirdImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(banner.cli_img)"
            v-if="getFourthImage(banner.cli_img)">   
          </v-carousel-item>
          <v-carousel-item 
            :src="getFifthImage(banner.cli_img)"
            v-if="getFifthImage(banner.cli_img)">   
          </v-carousel-item>
          <v-card-title class="align-end fill-height white--text ml-10 title-mobile">
              <b class="title-text-mobile"><i>{{ banner.description }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 logo-mobile">
          <v-list-item>
            <v-list-item-avatar size="60">
              <img :src="getImage(item.logos)" alt="Logo" />
            </v-list-item-avatar>
          </v-list-item>
        </v-card-title>
        <span class="mapit-mobile">
          <mapdirection/>
          <v-bottom-sheet v-model="sheet1" inset>
            <template v-slot:activator="{ on }">
              <v-btn fab small rounded color="grey lighten-1" 
                style="left: 85px; position: relative; bottom: 2px;" 
                v-on="on">
                <v-icon>
                  mdi-share
                </v-icon>
              </v-btn>
            </template>
            <v-sheet class="text-center" height="100px">
              <div class="label"><b>Share This Client:</b></div>
                <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/service'+ item.slug" :title="item.name" :description="item.description" quote="This Client is from Convergeo click here to view.." hashtags="convergeo services" twitter-user="Convergeo" inline-template>
                  <div>
                    <network network="facebook">
                      <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                    </network>
                    <network network="linkedin">
                      <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                    </network>
                    <network network="pinterest">
                      <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                    </network>
                    <network network="skype">
                      <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                    </network>
                    <network network="twitter">
                      <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                    </network>
                    <network network="whatsapp">
                      <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                    </network> 
                  </div>
                </social-sharing>
            </v-sheet>
          </v-bottom-sheet>
        </span>
        <v-card-title class="align-end fill-height white--text ml-10 main-title-mobile">
          <b class="main-title-text-mobile">
            {{ item.displayName | uppercase }}
          </b>
        </v-card-title>
        <v-card-title class="align-end fill-height white--text crumb-mobile">
          <router-link to="/">Home</router-link>
          <v-icon>mdi-forward</v-icon>
          {{  item.displayName | capitalize }}
        </v-card-title>
        </span>
      </v-carousel>
      <v-tabs dark background-color="indigo lighten-4" show-arrows>
        <b class="hidden-sm-and-down" v-if="extendy" @click="open_viewer">
          <v-icon color="grey darken-3" style="margin-top: 10px; ">
            mdi-arrow-down-drop-circle
          </v-icon>
        </b>
        <b class="hidden-sm-and-down" v-else @click="close_viewer">
          <v-icon color="grey darken-3" style="margin-top: 10px; ">
            mdi-arrow-up-drop-circle
          </v-icon>
        </b>
        <v-tabs-slider color="black"></v-tabs-slider>
        <v-tab v-if="producto">
          <b class="label" @click="open_viewer">
            Products
          </b>
        </v-tab><!--IF APPLICABLE -->
        <v-tab v-if="servico">
          <b class="label" @click="open_viewer">
            Services
          </b>
        </v-tab><!--IF APPLICABLE -->
        <v-tab v-if="evento">
          <b class="label" @click="open_viewer">
            Events
          </b>
        </v-tab><!--IF APPLICABLE -->
        <v-tab v-if="(filteredContact) || (filteredDocument)">
          <b class="label" @click="open_viewer">
            About us
          </b>
        </v-tab>
        <v-tab-item>
          <v-container fluid fill-height>
            <div class="columns is-multiline">
              <div class="column is-12 hidden-sm-and-down">
                <v-layout>
                  <v-flex xs2>
                    <v-card-title>Filter|</v-card-title>
                  </v-flex>
                  <v-flex xs3>
                    <v-select :items="subcategories" label="Categories"></v-select>
                  </v-flex>
                  <v-flex xs1>
                  </v-flex>
                  <v-flex xs3>
                     <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Search ' +  $route.params.slug" single-line hide-details></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                  </v-flex>
                  <v-flex xs3>
                     <v-switch v-model="tick" label="Show Only Sale Items" color="indigo darken-3" value="" hide-details></v-switch>
                  </v-flex>
                </v-layout>
              </div>
              <div class="column is-12 hidden-md-and-up">
                <v-layout>
                  <v-flex xs4>
                    <v-card-title>Filter|</v-card-title>
                  </v-flex>
                  <v-flex xs8>
                     <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Products" single-line hide-details></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div class="column is-3" v-for="product in producto" :key="product.id">
                <product :product="product"/>
              </div>
            </div>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid fill-height>
            <v-layout>
            <div class="columns is-multiline">
              <div class="column is-3" v-for="service in servico" :key="service">
                <v-card class="elevation-4" width="30%">
                  <router-link :to="/service/ + service.slug"><v-img height="180" :src="getServiceImg(service.image)"  responsive :lazy-src="getServiceImg(service.image)" >
                    <v-card-title class="align-end fill-height">
                      {{service.name}}
                    </v-card-title>
                  </v-img></router-link>
                  <v-card-text>
                    <div class="my-4 subtitle-1 black--text">
                      <span class="label">
                        {{service.town_code[0]}}
                      </span>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid fill-height>
            <v-layout>
              <div class="columns is-multiline">
                <div class="column is-12 hidden-sm-and-down">
                  <v-layout>
                    <v-flex xs2>
                      <v-card-title>Filter |</v-card-title>
                    </v-flex>
                    <v-flex xs3>
                      <v-select :items="subcategories" label="Categories"></v-select>
                    </v-flex>
                    <v-flex xs1>
                    </v-flex>
                    <v-flex xs3>
                       <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Search ' +  $route.params.slug" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs1>
                    </v-flex>
                    <v-flex xs3>
                       <v-switch v-model="tick" label="Show Only Sale Items" color="indigo darken-3" value="" hide-details></v-switch>
                    </v-flex>
                  </v-layout>
                </div>
                <div class="column is-12 hidden-md-and-up">
                  <v-layout>
                    <v-flex xs4>
                      <v-card-title>Filter|</v-card-title>
                    </v-flex>
                    <v-flex xs8>
                       <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Products" single-line hide-details></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>
                <div class="column is-3" v-for="event in evento" :key="event.id">
                  <event :event="event" style="pointer-events: auto;"/>
                </div>
              </div>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <div class="columns">
            <div class="column is-8">
              <div class="text-center" v-for="doc in filteredDocument" :key="doc.id">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn color="blue lighten-2" rounded dark v-on="on">
                      {{doc.name | capitalize}}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      {{doc.name | capitalize}}
                    </v-card-title>
                    <v-card-text>
                      <p v-html="doc.description"></p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false">
                        Okay Reddit...
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </div>
            <div class="column is-4">
              <div v-for="contact in filteredContact" :key="contact.id">
                <v-card v-if="contact.gen_name">
                  <card-title class="font-weight-bold subtitle-1">
                    {{contact.gen_name}}
                  </card-title>
                  <v-layout>
                    <v-flex x4 v-if="contact.gen_facebook">
                      <a :href="'https://facebook.com/'+ contact.gen_facebook" target="_blank"><v-icon color="blue darken-1">mdi-facebook-box</v-icon></a>
                    </v-flex>
                    <v-flex x4 v-if="contact.gen_instagram">
                      <a :href="'https://instagram.com/'+ contact.gen_instagram" target="_blank"><v-icon color="purple lighten-3">mdi-instagram</v-icon></a>
                    </v-flex>
                    <v-flex x4 v-if="contact.gen_twitter">
                      <a :href="'https://twitter.com/'+ contact.gen_twitter" target="_blank"><v-icon color="blue lighten-3">mdi-twitter</v-icon></a>
                    </v-flex>
                  </v-layout>
                  <v-text v-if="contact.gen_a_cell">
                    <b>
                      <v-icon color="red lighten-2">mdi-phone</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      Airtel
                    </b>
                    {{contact.gen_a_cell}}
                  </v-text><br>
                  <v-text v-if="contact.gen_m_cell">
                    <b>
                      <v-icon color="yellow lighten-2">mdi-phone</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      MTN
                    </b>
                    {{contact.gen_m_cell}}
                  </v-text><br>
                  <v-text v-if="contact.gen_z_cell">
                    <b>
                      <v-icon color="green lighten-2">mdi-phone</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      Zamtel
                    </b>
                    {{contact.gen_z_cell}}
                  </v-text>
                </v-card>
                <br>
                <v-card v-if="contact.mem_name">
                  <card-title class="font-weight-bold subtitle-1">
                    {{contact.mem_name}}
                  </card-title>
                  <br>
                  <v-layout>
                    <v-flex x4 v-if="contact.mem_facebook">
                      <a :href="'https://facebook.com/'+ contact.mem_facebook" target="_blank"><v-icon color="blue darken-1">mdi-facebook-box</v-icon></a>
                    </v-flex>
                    <v-flex x4 v-if="contact.mem_instagram">
                      <a :href="'https://instagram.com/'+ contact.mem_instagram" target="_blank"><v-icon color="purple lighten-3">mdi-instagram</v-icon></a>
                    </v-flex>
                    <v-flex x4 v-if="contact.mem_twitter">
                      <a :href="'https://twitter.com/'+ contact.mem_twitter" target="_blank"><v-icon color="blue lighten-3">mdi-twitter</v-icon></a>
                    </v-flex>
                  </v-layout>
                  <v-text v-if="contact.mem_title">
                    <b>
                      <v-icon>mdi-subtitles mdi-24px</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      Title:
                    </b>
                    {{contact.mem_title}}
                  </v-text><br>
                  <v-text v-if="contact.mem_name">
                    <b>
                      <v-icon>mdi-account mdi-24px</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      Name:
                    </b>
                    {{contact.mem_name}}
                  </v-text><br>
                  <v-text v-if="contact.mem_cell">
                    <b>
                      <v-icon color="grey darken-2">mdi-phone</v-icon>
                      <v-divider class="mx-1" inset vertical></v-divider>
                      Contact:
                    </b>
                    {{contact.mem_cell}}
                  </v-text>
                </v-card>
              </div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs>
    </v-content>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {fb,db} from '@/firebase'
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)
  import { mapState, mapGetters, mapActions } from 'vuex'
  import mapdirection from '@/components/Client/map.vue'

  export default {
    name: 'client',
    data: () => ({
      item: null,
      extendy: true,
      servico: [],
      producto: [],
      evento: [],
      user: null,
      bannerSettings: {
        itemsToShow: 1,
        rtl: true,
        centerMode: false,
        autoPlay: true,
        playSpeed: 5000
      },
      comments: {
        client_id: '',
        client_slug: '',
        client_comment: '',
        user_id: '',
        user_name: ''
      },
      commento: [],
      ratingo: [],
      ratings: {
        client_id: '',
        client_slug: '',
        client_rating: '',
        user_id: ''
      },
      dialog: false,
      dialog1: false,
      sheet: false,
      sheet1: false,
      index: null
    }),

    mounted() {
      this.initClientm(this.$route.params.slug)
    },

    methods: {
      getImage(logos){
        return logos[0]
      },

      getServiceImg(image){
        return image[0]
      },

      getFirstImage(cli_img){
        return cli_img[0]
      },

      getSecondImage(cli_img){
        return cli_img[1]
      },

      getThirdImage(cli_img){
        return cli_img[2]
      },

      getFourthImage(cli_img){
        return cli_img[3]
      },

      getFifthImage(cli_img){
        return cli_img[4]
      },

      open_viewer(){
        this.extendy = false
      }, 
      close_viewer(){
        this.extendy = true
      },
      ...mapActions('clientsModule', 
        [ 
          'initClientm', 
          'initContacts',
          'initClientImg',
          'initClientInfo'
        ]
      ),
      back(){
        this.$router.go(-1)
      },

      addNew(){
        this.reset()
        this.dialog = true
      },
      ratingSum(){
        return this.ratingo.reduce((prev,cur) => prev + cur.client_rating,0)
      },
      reset(){
        this.ratings = {
          client_id: '',
          client_slug: '',
          client_rating: '',
          user_id: ''
        }
        this.comments = {
          client_id: '',
          client_comment: '',
          client_slug: '',
          user_name: '',
          user_id: ''
        }  
      },
      addServiceComments(){
        db.collection('comments').add({
            client_id: this.item.id,
            client_slug: this.item.slug,
            user_name: this.user.name,
            client_comment: this.comments.client_comment,
            user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          console.log(err);
        })
        /* eslint-enable */
      },
      addServiceRating(){
        db.collection('ratings').add({
          client_id: this.item.id,
          client_slug: this.item.slug,
          client_rating: this.ratings.client_rating,
          user: fb.auth().currentUser.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
        }) 
      },
      updateServiceRating(){
        db.collection('ratings').doc(this.item.id).update({
          quantity: ((this.item.quantity)-(this.quantityValue))
        })
      },
      close () {
        this.dialog = false
      }
    },

    components: {
      mapdirection
    },

    created(){
      //get item data 
      let ref = db.collection('clients')
      .where('slug', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
            //console.log(doc.data());
            this.item = doc.data()
            this.item.id = doc.id
        })
        /* eslint-disable */
        console.log(this.item);
        /* eslint-enable */
      })

      db.collection('products')
      // .where('client_slug','==',this.$route.params.slug)
      .get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let product = doc.data()
          product.id =  doc.id
          this.producto.push(product) 
        })
      })

      db.collection('services')
      .where('client','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let service = doc.data()
          service.id =  doc.id
          this.servico.push(service) 
        })
      })

      db.collection('events')
      .where('client_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let event = doc.data()
          event.id =  doc.id
          this.evento.push(event) 
        })
      })

      db.collection('comments')
      .where('client_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let comment = doc.data()
          comment.id =  doc.id
          this.commento.push(comment) 
        })
      })

      db.collection('ratings')
      .where('client_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let rating = doc.data()
          rating.id =  doc.id
          this.ratingo.push(rating) 
        })
      })

      //get current user
      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },

    computed: {
      ...mapState('clientsModule', 
        [
          'contacts',
          'client_img',
          'client_info'
        ]),

      ...mapGetters({
        clim: 'clientsModule/clim'
      }),

      filteredCarousel() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.client_img.filter(view =>
            (view.title).match(regexp))
        }
        return this.client_img
      },

      filteredDocument() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.client_info.filter(view =>
            (view.name).match(regexp))
        }
        return this.client_info
      },

      filteredContact() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.contacts.filter(view =>
            (view.gen_name).match(regexp))
        }
        return this.contacts
      },

      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      '$route.params.slug': () => {
        this.initClientm(this.$route.params.slug)
      },
      clim() {
        if (this.clim.id) {
          this.initContacts(this.clim.id)
          this.initClientImg(this.clim.id)
          this.initClientInfo(this.clim.id)
        }
      }
    }
  }
</script>

<style scoped>
  .logo {
    position: absolute;
    bottom:260px;
  }
  .mapit {
    position: absolute;
    bottom: 300px;
    right: 5%;
    pointer-events: auto;
  }
  .crumb {
    position: absolute;
    top: -5px;
    left: 25px;
    font-size: 25px 
  }
  .main-title {
    position: absolute;
    bottom: 90px;
    left: -15px;
  }
  .title {
    position: absolute;
    bottom: 20px;
    left: -15px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>

<style scoped>
  .logo-mobile {
    position: absolute;
    bottom: 110px;
    left: -65px;
  }
  .mapit-mobile {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: +5;
    pointer-events: auto;
  }
  .type-mobile {
    position: absolute;
    bottom: 120px;
    right: 2px;
  }
  .date-mobile {
    position: absolute;
    bottom: 100px;
    right: 2px;
  }
  .time-mobile {
    position: absolute;
    bottom: 80px;
    right: 2px;
  }
  .main-title-mobile {
    position: absolute;
    top: -20px;
    left: -40px;
  }
  .title-mobile {
    position: absolute;
    top: 1px;
    left: -40px;
  }
  .crumb-mobile {
    position: absolute;
    top: 20px;
    font-size: 17px;
  }
  .main-title-text-mobile {
    font-size: 25px;
  }
  .title-text-mobile {
    font-size: 20px;
  }
  .left {
    float: right;
  }
</style>
